import { Directive, HostBinding, HostListener, Input, inject } from '@angular/core'
import { MatRipple } from '@angular/material/core'

@Directive({
	selector: '[actioner-rounded]',
	providers: [MatRipple],
	standalone: true,
})
export class ActionerRoundedDirective {
	readonly #ripple = inject(MatRipple)

	@Input() type: 'button' | 'submit' = 'button'
	@Input() color: 'main' | 'accent' | 'warn' | 'basic' | 'primary' = 'basic'

	@HostBinding('class.actioner-rounded') readonly setStyle = true

	@HostBinding('class') get setColor(): string {
		return this.color
	}

	#setRippleColor(): string {
		if (this.color === 'main') {
			return 'rgb(0 173 168 / 16%)'
		}

		if (this.color === 'accent') {
			return 'rgb(253 216 53 / 16%)'
		}

		if (this.color === 'warn') {
			return 'rgb(199 33 0 / 16%)'
		}

		if (this.color === 'primary') {
			return 'rgb(58 108 217 / 16%)'
		}

		return 'rgb(255 255 255 / 16%)'
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent): void {
		this.#ripple.launch(event.x, event.y)
		this.#ripple.color = this.#setRippleColor()
	}
}
